import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Collections, Parts, Types, Elements} from "components";

import {Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";


/**
 *  @property {Transactions_Collections_Object} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class DavidsonsTransferObject extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_TRANSFER';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_TRANSFER' : 'PUT_TRANSFER';
		this.delete = 'DELETE_TRANSFER';
	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.transaction || (object.binary_id + '-' + object.pkey));
		}

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		// if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
		// 	//Then check related props
		// 	//If "Internal" select was updated, update corresponding Dealer Information
		// 	if (object.locations_related_by_internal && object.internal !== prevState.internal) {
		// 		this.setState({
		// 			'dealer_name_company': object.internal ? object.locations_related_by_internal.name_display || object.locations_related_by_internal.name : '',
		// 			'dealer_ffl': object.internal ? object.locations_related_by_internal.ffl : ''
		// 		});
		// 	}
		// 	//If "Dealer" select was updated, update corresponding Dealer Information
		// 	if (object.dealers && object.dealer !== prevState.dealer) {
		// 		this.setState({
		// 			'dealer_name_company': object.dealer ? object.dealers.name_display || object.dealers.name_trade || object.dealers.name_company : '',
		// 			'dealer_ffl': object.dealer ? object.dealers.ffl : ''
		// 		});
		// 	}
		// }
	}

	// // noinspection JSUnusedGlobalSymbols
	// /**
	//  * @param {Transactions_Collections_Object} data
	//  */
	loadSelfAfter(data) {
		if (data.internal != null) {
			this.setState({'acquired_from': 'internal'});
		} else if (data.dealer != null) {
			this.setState({'acquired_from': 'dealer'});
		} else if (data.customer != null) {
			this.setState({'acquired_from': 'customer'});
		}

		if (data.pawn_inventory || data.pawn_ticket) {
			this.setState({'is_pawn': true});
		}

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.transaction || (data.binary_id + '-' + data.pkey));
		}
	};

	form = () => {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>

							{/*#endregion*/}

							{/*#region Details Section*/}
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Items Section*/}
							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary" data-id={'quick-transfer-products'}>
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"Davidsons Products"}
										object={Collections.DavidsonsProducts}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
									/>

								</div>
							</h4>

							{object.transaction_entriess && object.transaction_entriess.map(
								(entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
									/>
							)}
							<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}
